var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 14.25H9V5.25H19.5V14.25ZM10.125 13.125H18.375V6.375H10.125V13.125ZM15 18.75H4.5V9.75H7.875V10.875H5.625V17.625H13.875V15.375H15V18.75Z",
    fill: "#116F9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandWindow);
export default __webpack_public_path__ + "static/media/expand_window.e8dd237ec6d605ee909e224c1e4f0bc4.svg";
export { ForwardRef as ReactComponent };